import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { IQueryState } from '@shared/store/reducers/query.reducer';
import { select, Store } from '@ngrx/store';
import { getQueryResponse } from '@shared/store/selectors/query.selector';
import { QueryProvider } from '@shared/queries/query-provider';
import { Observable, Subject } from 'rxjs';
import { SmartFilterBase } from '@shared/components/smart-filters/smart-filter-base.component';
import { takeUntil } from 'rxjs/operators';
import { RelatedTool } from '@shared/models/related-tool.model';
import { RelatedToolsDialogComponent } from '@shared/components/related-tools-dialog/related-tools-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TaxNewsTooltips } from '../constants/dashboard.constants';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { StringUtility } from '@shared/utility/string-utility';

@Component({
    standalone: false,
    selector: 'particle-tax-news-widget',
  templateUrl: './tax-news-widget.component.html',
  styleUrls: ['./tax-news-widget.component.scss']
})
export class TaxNewsWidgetComponent extends SmartFilterBase implements OnInit, OnDestroy {
  newsItems$: Observable<any>;
  hasData: boolean = false;
  newsItems: any;
  categoryIds: string[] = [];
  newsDateString: string;
  currentExpandedItemIndex: number = 0;
  actualNewsDate$: Observable<any>;
  actualNewsDate: string;
  dataFetchCount: number;
  unsubscribe$ = new Subject<void>();
  dataLoaded: boolean = false;
  inited: boolean = false;
  itrceApprovedTooltipText = TaxNewsTooltips.ITRCE_APPROVED_TOOLTIP_TEXT;
  crApprovedTooltipText = TaxNewsTooltips.CR_APPROVED_TOOLTIP_TEXT;
  readApprovedTooltipText = TaxNewsTooltips.READ_APPROVED_TOOLTIP_TEXT;

  itrceProposedTooltipText = TaxNewsTooltips.ITRCE_PROPOSED_TOOLTIP_TEXT;
  crProposedTooltipText = TaxNewsTooltips.CR_PROPOSED_TOOLTIP_TEXT;
  readProposedTooltipText = TaxNewsTooltips.READ_PROPOSED_TOOLTIP_TEXT;

  itrceTreatyTooltipText = TaxNewsTooltips.ITRCE_TREATY_TOOLTIP_TEXT;
  crTreatyTooltipText = TaxNewsTooltips.CR_TREATY_TOOLTIP_TEXT;
  readTreatyTooltipText = TaxNewsTooltips.READ_TREATY_TOOLTIP_TEXT;


  constructor(public changeDetectorRef: ChangeDetectorRef, private store: Store<IQueryState>, private dialog: MatDialog, private activatedRoute: ActivatedRoute, private router: Router, private elementRef: ElementRef) {
    super(changeDetectorRef);
  }

  ngOnInit() {
    this.inited = false;
    this.dataFetchCount = 0;
    this.dataLoaded = false;
    this.newsItems$ = this.store.pipe(select(getQueryResponse, this.currentFilter.arguments['QueryKey']));
    this.newsItems$.pipe(takeUntil(this.unsubscribe$)).subscribe(newsItems => {

      if (this.inited) {
        this.dataLoaded = true;
      }
      this.inited = true;
      this.dataFetchCount++;
      this.newsItems = newsItems;
      this.hasData = this.newsItems && this.newsItems.recordCount > 0;
      this.currentFilter.title = this.hasData ? `Tax News (${this.newsItems.recordCount})` : 'Tax News';
      this.categoryIds = this.hasData ? this.newsItems.newsCategories.map(category => StringUtility.getDashCase(category.title)) : [];
      if (this.queryParameters && this.queryParameters.groupId) {
        if (this.hasData) {
          const currentItem = this.newsItems.newsCategories.find(category => StringUtility.getDashCase(category.title) === this.queryParameters.groupId);
          this.currentExpandedItemIndex = currentItem ? this.newsItems.newsCategories.indexOf(currentItem) : 0;
        } else if (this.dataFetchCount > 1) {
          delete this.queryParameters.groupId;
          this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: this.queryParameters });
        }
      }
    });

    this.activatedRoute.queryParams.pipe(takeUntil(this.unsubscribe$)).subscribe(queryParams => {
      this.queryParameters = { ...queryParams };
      if (queryParams.newsDate) {
        if (this.newsDateString !== queryParams.newsDate) {
          this.dataLoaded = false;
          this.newsDateString = queryParams.newsDate;
          QueryProvider.invokeQuery(this.store, this.currentFilter.arguments['QueryKey'], {
            '[NEWS_DATE]': this.newsDateString
          });
          QueryProvider.invokeQuery(this.store, this.currentFilter.arguments['ActualNewsDateQueryKey'], {
            '[NEWS_DATE]': this.newsDateString
          });
        }
      }
    });


    this.actualNewsDate$ = this.store.pipe(select(getQueryResponse, this.currentFilter.arguments['ActualNewsDateQueryKey']));
    this.actualNewsDate$.pipe(takeUntil(this.unsubscribe$)).subscribe(payload => {
      // console.log(taxNewsSummary.actualNewsDate);
      if (payload) {
        this.actualNewsDate = payload.taxNewsSummary.actualNewsDate;
      }
    });
  }

  onClickRelatedTools(tools: RelatedTool[]) {
    const obj = {
      relatedTools: tools
    };
    const dialogRef = this.dialog.open(RelatedToolsDialogComponent, {
      data: obj
    });
    dialogRef.afterClosed().pipe(takeUntil(this.unsubscribe$)).subscribe(result => {
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  expanded(dashedCategoryTitle: string) {
    this.queryParameters.groupId = dashedCategoryTitle;
    this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: this.queryParameters });
  }
}
